import { useCallback } from "react";

import { TopLevelShowLoginStateReason } from "@bokio/contexts/TopLevelUserContext/TopLevelUserContext";
import { useTopLevelUser } from "@bokio/contexts/TopLevelUserContext/useTopLevelUser";
import { useIdleTimer } from "@bokio/hooks/useIdleTimer/useIdleTimer";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";

import type { FC, PropsWithChildren } from "react";

export const AuthenticationChecker: FC<PropsWithChildren> = ({ children }) => {
	const { showLogin, setShowLogin } = useTopLevelUser();

	const checkAuthentication = useCallback(async () => {
		const response = await proxy.Bokio.AccountController.IsAuthenticated.Get();
		if (response.Success && response.Data) {
			showLogin && setShowLogin(null);
		} else {
			setShowLogin({ reason: TopLevelShowLoginStateReason.Idle });
		}
	}, [showLogin, setShowLogin]);

	useIdleTimer({
		onActive: checkAuthentication,
		idleTimeout: 60_000,
	});

	return <>{children}</>;
};
